/* @flow */

import {type ColorName} from 'shells/colors';

import {type OpenableModalId, OpenableModals} from '../openable-modals/openable-modals';

export type LearnMoreConfig = {|
    openableModalId: OpenableModalId,
    label?: string,
|};

export type FeedbackSurvey = {|
    id: string,
    pathNames: Array<string>,
    bannerTitle: string,
    surveyTitle: string,
    surveySubtitle: string,
    expireDate?: string,
    feedbackPrompt?: string,
    surveyImage?: string,
    surveyImageBackgroundColor?: ColorName,
    learnMore?: LearnMoreConfig,
|};

/*
    - use * as a wildcard to match certain dynamic paths (ex: /lead/* would match /lead/123, /lead/456, etc.)
    - use \n to create line breaks in the surveyTitle and surveySubtitle
    - learnMore is optional and can be used to open an onboarding modal when the user clicks "Learn more"
*/
export const FEEDBACK_SURVEYS: Array<FeedbackSurvey> = [
    {
        id: 'tasks-report',
        pathNames: ['/reports/tasks'],
        bannerTitle: 'Track your team’s performance with our new tasks report',
        surveyTitle: 'Tell us what you think about the new tasks report',
        surveySubtitle:
            'Did you find the tasks report helpful?\nHow does your team track your sales process performance?\nIs there anything missing from this report you’d like to see?',
        surveyImage: '/include/images/onboarding/tasks-report.svg',
    },
    {
        id: 'product-categories',
        pathNames: ['/sales/product', '/sales/product/categories'],
        bannerTitle: 'Product categories are now available',
        surveyTitle: 'Tell us what you think about product categories',
        surveySubtitle:
            'Did you find the addition of product categories helpful?\nAre there additional features or functionality your team could benefit from being added to product categories?',
        surveyImage: '/include/images/onboarding/product-category-illustration.svg',
    },
    {
        id: 'engagement-report',
        pathNames: ['/reports/engagement'],
        bannerTitle: 'Track your engagement funnel with the new engagement report',
        surveyTitle: 'Tell us what you think about the engagement report',
        surveySubtitle:
            "Did you find the engagement report helpful?\nHow does your team track your engagement funnel performance?\nIs there anything missing from this report you'd like to see?",
        surveyImage: '/include/images/onboarding/funnel-report-illustration.svg',
        learnMore: {
            openableModalId: OpenableModals.ENGAGEMENT_REPORT_ONBOARDING_MODAL,
            label: 'Learn more',
        },
    },
];
